import { Box, FormGroup, styled } from "@mui/material";
import { colors } from "../../Themes/colors";
export var DatePickerWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .cstDatepicker": {
            "& .MuiStack-root:first-child": {
                paddingTop: 0,
            },
            "& .MuiInputBase-input": {
                padding: "8.4px 14px",
            },
        },
    });
});
export var CheckboxWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiFormControlLabel-root": {
            "& .MuiButtonBase-root": {
                padding: 0,
                "&.MuiCheckbox-root": {
                    "&.Mui-checked": {},
                },
            },
            gap: 10,
            "& .MuiFormControlLabel-label": {
                fontSize: 14,
            },
        },
        "& .chackBoxgroup": {
            border: "1px solid ".concat(colors.greyShades[12]),
            borderRadius: "4px",
            padding: "10px 20px",
            "& .checkBoxView": {
                "& .MuiTypography-root": {
                    display: "list-item",
                },
            },
        },
    });
});
export var FormGroupWrapper = styled(FormGroup)(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: "row",
        "& .MuiTypography-root": {
            fontSize: 14,
            paddingLeft: 8,
        },
        "& .MuiButtonBase-root": {
            padding: 0,
            mx: 1,
        },
        "& .MuiFormControlLabel-root": {
            marginLeft: 0
        }
    });
});
